// setup axios global interceptors
import axios from "axios";
import { logDetailed } from "../helpers/utils";

logDetailed("axiosSetup", "root", "setting up axios");

axios.defaults.baseURL = window.apiBaseURL || "/";
axios.defaults.withCredentials = true;
axios.defaults.headers.get["Cache-Control"] = "no-cache";
axios.defaults.headers.get["Pragma"] = "no-cache";
axios.defaults.headers.get["Expires"] = "0";

axios.interceptors.request.use(logApiRequest)
axios.interceptors.response.use(logSuccessfulApiResponse, logFailedApiResponse);

function logApiRequest(req) {
  logDetailed("actions", "logApiRequest", { method: req.method, url: req.url });
  return req;
}

function logSuccessfulApiResponse(res) {
  logDetailed("actions", "logSuccessfulApiResponse",
    { method: res.config.method, url: res.config.url, status: res.status, statusText: res.config.statusText });
  return res;
}

function logFailedApiResponse(res) {
  logDetailed("actions", "logFailedApiResponse",
    { method: res.config.method, url: res.config.url, status: res.status, statusText: res.config.statusText });
  return Promise.reject(res);
}